module.exports = __webpack_public_path__ + "img/20170319-5.012c0130.jpeg";